@if (form) {
  <mat-card>
    <app-card-header
      [title]="title"
      icono="videocam"
      [botonCerrar]="true"
      (cerrar)="dialogRef.close()"
    ></app-card-header>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <!-- Cámara -->
        <section class="inputs-group">
          <ng-select
            [items]="data.camarasDeAlarma"
            bindLabel="identificacion"
            bindValue="_id"
            formControlName="idCamara"
            placeholder="Cámara"
            [notFoundText]="'No hay cámaras asignadas'"
            style="width: 100%"
            multiple="false"
            searchable="true"
            appendTo="body"
            (change)="camaraElegida()"
          ></ng-select>
        </section>

        <!-- Canal -->
        <section class="inputs-group">
          <ng-select
            [items]="canalesCamaraElegida"
            formControlName="canal"
            bindValue="numero"
            placeholder="Canal de la cámara"
            [notFoundText]="'No hay cámaras seleccionada'"
            style="width: 100%"
            multiple="false"
            searchable="true"
            appendTo="body"
          >
            <ng-template ng-label-tmp let-item="item">
              Número de canal:
              {{ item.numero }} Nombre: {{ item.nombre }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              Número de canal:
              {{ item.numero }} Nombre: {{ item.nombre }}
            </ng-template>
          </ng-select>
        </section>

        <!-- Partición y zona -->
        <section class="inputs-group">
          <mat-form-field style="flex: 1">
            <mat-label>Partición de la alarma</mat-label>
            <input matInput formControlName="particion" />
          </mat-form-field>

          <mat-form-field style="flex: 1">
            <mat-label>Zona de la alarma</mat-label>
            <input matInput formControlName="zona" />
          </mat-form-field>
        </section>
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
          Cancelar
        </button>
        <button
          irxBoton="principal"
          type="submit"
          [disabled]="!this.form.valid"
        >
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
}
